import { PERMISSIONS } from '@core/constants/permissions.constants';
import { ReportConfig } from './sparepart-report.config';

export const USER_MASTER_LIST_REPORT_CONFIG: ReportConfig = {
  id: 'user-master-list',
  title: 'User Master List Report',
  permissions: {
    view: PERMISSIONS.GSE.REPORTS.USER_MASTER_LIST.VIEW,
    export: PERMISSIONS.GSE.REPORTS.USER_MASTER_LIST.EXPORT,
  },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search',
    },
    {
      type: 'dropdown',
      field: 'userStatus',
      label: 'Status',
      placeholder: 'Status',
      multiselect: false
    },
  ],

  columns: [
    {
      field: 'name',
      header: 'Name',
      type: 'text',
      width: '22%',
    },
    {
      field: 'email',
      header: 'Email',
      type: 'text',
      width: '28%',
    },
    {
      field: 'designation',
      header: 'Role',
      type: 'text',
      pipes: ['titlecase'],
      width: '25%',
    },
    {
      field: 'userStatus',
      header: 'Status',
      type: 'text',
      pipes: ['titlecase'],
      width: '25%',
    },
  ],
};
